// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
var unsafeHead = /* #__PURE__ */ (function () {
    var $22 = Data_Maybe.fromJust();
    return function ($23) {
        return $22(Data_Array.head($23));
    };
})();
var unsafeGet = function (arr) {
    return function (i) {
        return Data_Maybe.fromJust()(Data_Array.index(arr)(i));
    };
};
var tupleToAccum = function (v) {
    return {
        accum: v.value0,
        value: v.value1
    };
};
var accumToTuple = function (v) {
    return new Data_Tuple.Tuple(v.accum, v.value);
};
var mapAccumLTuple = function (dictTraversable) {
    return function (f) {
        return function (s) {
            return function (xs) {
                var f$prime = function (r) {
                    return function (a) {
                        return tupleToAccum(f(r)(a));
                    };
                };
                return accumToTuple(Data_Traversable.mapAccumL(dictTraversable)(f$prime)(s)(xs));
            };
        };
    };
};
var maximalCliques = function (pickpivot) {
    return function (neighborsOf) {
        return function (nodeset) {
            var go = function (r) {
                return function (p) {
                    return function (x) {
                        if (Data_Set.isEmpty(p) && Data_Set.isEmpty(x)) {
                            return [ r ];
                        };
                        if (Data_Boolean.otherwise) {
                            var step$prime = function (v) {
                                return function (v1) {
                                    var nv = neighborsOf(v1);
                                    return new Data_Tuple.Tuple(new Data_Tuple.Tuple(Data_Set["delete"](Data_Ord.ordInt)(v1)(v.value0), Data_Set.insert(Data_Ord.ordInt)(v1)(v.value1)), go(Data_Set.insert(Data_Ord.ordInt)(v1)(r))(Data_Set.intersection(Data_Ord.ordInt)(nv)(v.value0))(Data_Set.intersection(Data_Ord.ordInt)(nv)(v.value1)));
                                };
                            };
                            var pivot = pickpivot(p)(x);
                            return Data_Array.concat(Data_Tuple.snd(mapAccumLTuple(Data_Traversable.traversableArray)(step$prime)(new Data_Tuple.Tuple(p, x))(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Set.difference(Data_Ord.ordInt)(p)(neighborsOf(pivot))))));
                        };
                        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.MaximalCliques (line 73, column 3 - line 89, column 112): " + [ r.constructor.name, p.constructor.name, x.constructor.name ]);
                    };
                };
            };
            return go(Data_Set.empty)(nodeset)(Data_Set.empty);
        };
    };
};
var getMaximalCliques = function (tolFun) {
    return function (xs) {
        var pickpivot = function (p) {
            return function (x) {
                return unsafeHead(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(p))(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(x)));
            };
        };
        var lnodes = Data_Array.zip(Data_Array.range(0)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(xs)))(xs);
        var lnodes$prime = Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return new Data_Tuple.Tuple(v.value1, Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordInt)(Data_Array.filter(function (v1) {
                return v1 !== v.value0;
            })(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(Data_Array.filter((function () {
                var $24 = tolFun(v.value1);
                return function ($25) {
                    return $24(Data_Tuple.snd($25));
                };
            })())(lnodes)))));
        })(lnodes);
        var lv = Data_Array.fromFoldable(Data_Foldable.foldableArray)(lnodes$prime);
        return Data_Functor.map(Data_Functor.functorArray)((function () {
            var $26 = Data_Functor.map(Data_Functor.functorArray)((function () {
                var $29 = unsafeGet(lv);
                return function ($30) {
                    return Data_Tuple.fst($29($30));
                };
            })());
            var $27 = Data_Array.fromFoldable(Data_Set.foldableSet);
            return function ($28) {
                return $26($27($28));
            };
        })())(maximalCliques(pickpivot)((function () {
            var $31 = unsafeGet(lv);
            return function ($32) {
                return Data_Tuple.snd($31($32));
            };
        })())(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordInt)(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(lnodes))));
    };
};
export {
    getMaximalCliques
};
//# sourceMappingURL=index.js.map
